import { render, staticRenderFns } from "./shareToMessenger.vue?vue&type=template&id=0d98464a&"
import script from "./shareToMessenger.vue?vue&type=script&lang=js&"
export * from "./shareToMessenger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports